(function(){
  'use strict';

  function normalizeWhyOne() {
    const sections = document.querySelectorAll('section, .shopify-section, [class*="section"]');
    let target = null;
    for (const s of sections) {
      const t = (s.textContent || '').toLowerCase();
      if (t.indexOf('magnesium l-threonate') > -1 && t.indexOf('organic fruit') > -1 && t.indexOf('himalayan salt') > -1) { target = s; break; }
    }
    if (!target) return;
    target.classList.add('one-why-section');
    target.querySelectorAll('img').forEach(function(img){
      img.style.aspectRatio = '1 / 1';
      img.style.width = '100%';
      img.style.height = 'auto';
      img.style.maxHeight = '380px';
      img.style.minHeight = '0';
      img.style.objectFit = 'cover';
      img.style.objectPosition = 'center';
      img.style.display = 'block';
      var p = img.parentElement;
      if (p) { p.style.aspectRatio = '1 / 1'; p.style.maxHeight = '380px'; p.style.overflow = 'hidden'; }
    });
  }

  function dedupeProductCardTitles() {
    const cards = document.querySelectorAll('[class*="product-card"]:not([class*="link"]):not([class*="content"]):not([class*="image"]):not([class*="badge"])');
    cards.forEach(function(card){
      const links = card.querySelectorAll('a[class*="product-card__link"], a[class*="product-card-link"]');
      links.forEach(function(link){
        const titleEls = link.querySelectorAll('span, h1, h2, h3, h4, h5, h6, p');
        titleEls.forEach(function(el){
          if (el.closest('img, picture')) return;
          if (el.classList && el.classList.contains('visually-hidden')) return;
          el.style.position = 'absolute';
          el.style.width = '1px';
          el.style.height = '1px';
          el.style.padding = '0';
          el.style.margin = '-1px';
          el.style.overflow = 'hidden';
          el.style.clip = 'rect(0,0,0,0)';
          el.style.whiteSpace = 'nowrap';
          el.style.border = '0';
        });
      });
    });
  }

  function getPageTitleStrings() {
    const t = (document.title || '').trim();
    const candidates = [t];
    // strip common suffix patterns: " — ONE", " — ONE Performance Drink Mix", " — ONE Premium Electrolytes...", " - ONE"
    const seps = [' — ', ' - ', ' – ', ' · ', ' | '];
    for (const sep of seps) {
      if (t.indexOf(sep) > -1) candidates.push(t.split(sep)[0].trim());
    }
    return candidates;
  }

  function hideDuplicatePageTitle() {
    if (!document.querySelector('.one-eyebrow')) return;
    const titles = getPageTitleStrings();
    document.querySelectorAll('h1').forEach(function(h){
      if (h.closest('header, [class*="header__"]')) return;
      const t = (h.textContent || '').trim();
      if (titles.indexOf(t) === -1) return;
      // hide JUST the immediate text-block wrapper (if it contains only this h1) — NEVER hide the whole section
      var container = h.closest('[class*="text-block"]');
      if (container && container.children.length === 1) {
        container.style.setProperty('display', 'none', 'important');
      } else {
        h.style.setProperty('display', 'none', 'important');
      }
    });
  }

  function runAll() {
    normalizeWhyOne();
    dedupeProductCardTitles();
    hideDuplicatePageTitle();
  }

  // Initial passes
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runAll);
  } else {
    runAll();
  }
  window.addEventListener('load', runAll);

  // Catch sections that render late (page title section sometimes hydrates after DOMContentLoaded)
  [100, 300, 800, 1500, 3000, 6000].forEach(function(ms){ setTimeout(runAll, ms); });

  // Observe DOM for additions — if Shopify lazy-renders the page title, hide it the moment it appears
  try {
    const mo = new MutationObserver(function(mutations){
      let needRun = false;
      for (const m of mutations) {
        if (m.addedNodes && m.addedNodes.length) { needRun = true; break; }
      }
      if (needRun) hideDuplicatePageTitle();
    });
    mo.observe(document.body, { childList: true, subtree: true });
    // Stop observing after 10s to avoid perf cost
    setTimeout(function(){ mo.disconnect(); }, 10000);
  } catch(e) {}
})();
